import React from 'react';
import {History} from 'history';
import {ActionFunction1, Action} from 'redux-actions';
import {UserRolesEnum} from '@pluto/users';
import {OnNumberSetState} from '@pluto/@types';
import {SetQuery} from '@pluto/set-history-query';
import {PagingParams, SetPage, SetRowsPerPage, Sort} from '@pluto/table';

export interface ContentPartnerStatus {
    active: boolean;
}

export enum ContentPartnerStatusName {
    Active = 'Active',
    InActive = 'Deactivated',
}

export interface ContentPartnersResponse {
    id?: number;
    partnerName: string;
    cmsPartnerId: string;
    active: boolean;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

export interface ContentPartnerState extends ContentPartnersResponse {
    total: number;
    rows: ContentPartnersResponse[];
}

export interface ContentPartnerPayload {
    payload: ContentPartnerState;
}

export interface ContentPartnerSaveHandlersProps {
    saveContentPartner: Function;
    onPushRouteToHistory: Function;
    values: ContentPartnerState & {isValidDate: boolean};
    id: number;
}

export interface ContentPartnerOnEffectCleanupProps {
    resetInitialValuesForEditingItem: Function;
}

export interface ContentPartnerOnEffectProps {
    setInitialValuesForEditingItem: Function;
    resetInitialValuesForEditingItem: Function;
    id: number;
}

export interface CreateContentPartnerProps {
    body: ContentPartnersResponse;
    id: number;
}

export enum ContentPartnerStatusEnum {
    Active = 'true',
    Inactive = 'false',
}

export enum ContentPartnerFiltersKeys {
    Status = 'active',
}

export interface ContentPartnersFiltersType {
    active?: string[];
}

export interface ContentPartnersFilterParams extends Sort, PagingParams {
    name?: string;
    active?: string[];
    roles?: UserRolesEnum[];
}

export type SetContentPartnersAction = ActionFunction1<
    ContentPartnersFilterParams,
    Action<Promise<any>>
    >;

export interface ContentPartnersFiltersHandlers extends ContentPartnersFilterParams {
    history: History;
    route: string;
    setFilters: React.Dispatch<React.SetStateAction<ContentPartnersFiltersType>>;
    setQuery: SetQuery<ContentPartnersFiltersType>;
    setPage: OnNumberSetState;
    getList: SetContentPartnersAction;
    key: ContentPartnerFiltersKeys;
}

export interface HandleMountParams {
    setContentPartners: SetContentPartnersAction;
    resetList?: () => void;
    setPage: SetPage;
    setRowsPerPage: SetRowsPerPage;
    params: ContentPartnersFilterParams;
    query: URLSearchParams;
}
